import request from '@utils/request';
import { IVolunteerJobList } from '@src/types';
// 根据BG获取期望工作城市
export async function getWorkCity(params) {
  const res = await request.post(`/api/official/mobile/job/getWorkCity`, params);
  return res;
}

/**
 * @description: 获取志愿单职位列表
 * @param {*} params
 * @return {*}
 */
export async function getVolunteerJobList(params): Promise<IVolunteerJobList> {
  const res = await request.post('/api/official/mobile/job/getVolunteerJobList', params);
  const list = (res?.list || []).map((item) => {
    item.jobId = item.jobUnionId;
    item.jobName = item.name;
    return item;
  });
  return { list };
}

// /api/official/mobile/apply/job 申请职位
export async function applyPosition(params) {
  const res = await request.post(`/api/official/mobile/apply/job`, params);
  return res;
}

// /api/official/mobile/recommend/boleInfo/get 是否绑定伯乐关系
export async function getBoleInfo(params) {
  try {
    const res = await request.post(`/api/official/mobile/recommend/getBoleInfo`, params);
    return res;
  } catch (e) {
    return {};
  }
}
// 历史投递信息
export async function getApplyInfo(params) {
  try {
    const res = await request.post(`/api/official/mobile/volunteer/apply/job/get`, params);
    return res;
  } catch (e) {
    return {};
  }
}

// 内推码校验
// /api/official/mobile/recommend/recommendationNum/check
export async function recommendationNumCheck(params) {
  try {
    const res = await request.post(`/api/official/mobile/recommend/recommendationNum/check`, params, {
      showErrorToast: false,
    });
    return res;
  } catch (e) {
    return {};
  }
}

// 获取意向数据枚举
export const getAspirationDirectionList = async (jobUnionId: string) => {
  const result = await request.post<any>(`/api/official/mobile/job/queryAspirationDirection?jobUnionId=${jobUnionId}`);
  return result;
};

// 查询历史项目笔试信息
export async function getCanContinueProject(params) {
  const res = await request.post('/api/official/mobile/job/canContinueProject', params);
  return res;
}

/**
 * @description: 禁投项目信息
 */
export interface IExclusiveProject {
  projectId: number;
  name: string;
}

/**
 * @description: 查询当前项目配置的禁投项目列表
 * 若"投递后禁投指定项目=开"，返回与当前项目互斥且用户已投递的项目列表；否则返回空数组
 * @param {{ projectId: number }} params
 */
export async function getExclusiveProjects(params: { projectId: number }): Promise<IExclusiveProject[]> {
  const res = await request.post('/api/official/mobile/apply/exclusive/projects', params);
  return res || [];
}
